var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopCmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 161,
    viewBox: "0 0 205 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 80.7734,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20.7734,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 126.773,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 138.773,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 38.7734,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 11.7734,
    r: 7,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_21380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.679 53.0293H59.1324C58.1537 53.0299 57.2152 53.419 56.5232 54.111C55.8311 54.8031 55.442 55.7416 55.4414 56.7203V123.282C55.442 124.261 55.8311 125.2 56.5232 125.892C57.2152 126.584 58.1537 126.973 59.1324 126.973H131.679C132.658 126.973 133.596 126.584 134.288 125.892C134.981 125.2 135.37 124.261 135.37 123.282V56.7203C135.37 55.7415 134.981 54.803 134.288 54.1109C133.596 53.4188 132.658 53.0298 131.679 53.0293Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9 103.844H63.9059C61.8675 103.844 60.2148 102.191 60.2148 100.152V41.3414C60.2148 39.303 61.8675 37.6504 63.9059 37.6504H126.9C128.938 37.6504 130.591 39.303 130.591 41.3414V100.152C130.591 102.191 128.938 103.844 126.9 103.844Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.152 50.0762H71.6602V52.7827H119.152V50.0762ZM119.152 60.4106H71.6602V63.1171H119.152V60.4106ZM119.152 70.7473H71.6602V73.4539H119.152V70.7473ZM119.152 81.0818H71.6602V83.7887H119.152V81.0818Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37 85.2649V57.8058L130.594 53.0293V85.2645H135.37V85.2649Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.963 87.7483L135.817 124.175C135.56 125.996 134.001 127.35 132.162 127.35H58.6458C56.8068 127.35 55.2482 125.996 54.991 124.175L48.0369 74.9536C47.7233 72.7315 49.4476 70.7461 51.6918 70.7461H74.3952C76.2342 70.7461 77.7927 72.0995 78.05 73.9203L78.9613 80.3663C79.2186 82.1874 80.7771 83.5408 82.6162 83.5408H137.309C139.552 83.5408 141.277 85.5262 140.963 87.7483H140.963Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.731 111.103H68.0782C67.7787 111.103 67.4894 110.993 67.2647 110.795C67.04 110.597 66.8952 110.324 66.8574 110.027L66.1736 104.613C66.1519 104.44 66.1673 104.264 66.2187 104.097C66.2701 103.93 66.3564 103.776 66.4718 103.645C66.5873 103.514 66.7292 103.41 66.8883 103.338C67.0474 103.266 67.2199 103.229 67.3944 103.229H123.414C123.589 103.229 123.761 103.266 123.921 103.338C124.08 103.41 124.222 103.514 124.337 103.645C124.452 103.776 124.539 103.93 124.59 104.097C124.642 104.264 124.657 104.44 124.635 104.613L123.951 110.027C123.914 110.324 123.769 110.597 123.544 110.795C123.319 110.993 123.03 111.103 122.731 111.103V111.103Z",
    fill: "#EAECF0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.457 144.36C154.457 146.858 153.658 149.184 152.285 151.143L153.742 156.367L148.067 154.986C145.933 156.227 143.403 156.949 140.687 156.949C133.082 156.949 126.917 151.312 126.917 144.36C126.917 137.406 133.082 131.77 140.687 131.77C148.292 131.77 154.457 137.406 154.457 144.36Z",
    fill: "url(#paint0_linear_657_21380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.145 144.359C137.145 145.228 136.44 145.933 135.571 145.933C134.702 145.933 133.997 145.228 133.997 144.359C133.997 143.49 134.702 142.785 135.571 142.785C136.44 142.785 137.145 143.49 137.145 144.359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.863 144.359C141.863 145.228 141.159 145.933 140.29 145.933C139.421 145.933 138.716 145.228 138.716 144.359C138.716 143.49 139.421 142.785 140.29 142.785C141.159 142.785 141.863 143.49 141.863 144.359Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.375 144.359C147.375 145.228 146.671 145.933 145.801 145.933C144.932 145.933 144.228 145.228 144.228 144.359C144.228 143.49 144.932 142.785 145.801 142.785C146.671 142.785 147.375 143.49 147.375 144.359Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_21380",
    x1: 154.457,
    y1: 144.359,
    x2: 126.917,
    y2: 144.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_21380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white",
    transform: "translate(48 36)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCmsIcon);
export default __webpack_public_path__ + "static/media/top-cms-icon.27faa4455b2856757acddc2f792f72d9.svg";
export { ForwardRef as ReactComponent };